<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="FAQ"
      subtitle="FAQ"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <h1 class="sub_subject">FAQ<span></span></h1>
        <div class="scbd co-default">
          <div class="detail" style="position: relative">
            <SubLoading v-if="isLoading" />
            <div v-else-if="error">
              <p>{{ error }}</p>
            </div>
            <div v-else>
              <div class="hgroup" v-if="faqItem">
                <h1>{{ faqItem.question }}</h1>
                <ul>
                  <li>{{ faqItem.author }}</li>
                  <li>{{ common.getYYYYMMDD2(faqItem.createdDate) }}</li>
                  <li v-if="faqItem.ip">{{ faqItem.ip }}</li>
                </ul>
              </div>
              <div class="conbody">
                <div v-html="contentMessage"></div>
              </div>
            </div>
            <div class="btngroup">
              <div class="divider-line"></div>
              <router-link :to="`${USER_ROUTES.Qna.Path}`" class="ui-button"
                >목록</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import SubLoading from "@/components/SubLoading.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import type { Qna } from "@/model/qna";

const route = useRoute();
const router = useRouter();

const faqItem = ref<Qna | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);
const contentMessage = ref<string | null>(null);

const getCallApiCallable = getCallable("callApi");
const getQna = "getBoard";

const loadFaqDetail = async (sk: string) => {
  contentMessage.value = ""; // 이전 내용 초기화
  isLoading.value = true;
  error.value = null;
  try {
    let param = makeCallApiParam(getQna, {
      boardType: constant.boardType.QNA,
      SK: sk,
    });
    const result: any = await getCallApiCallable(param);
    if (common.evalFunctionResult(result)) {
      faqItem.value = common.getItemFromFunctionResult(result);
      contentMessage.value = faqItem.value.answer;
    } else {
      throw new Error(common.getResultError(result) || "FAQ 조회 실패");
    }
  } catch (err) {
    console.error("FAQ 로딩 실패:", err);
    error.value = "FAQ 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.";
    contentMessage.value = "표시할 내용이 없습니다.";
    faqItem.value = null;
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  const faqId = route.params.id as string;
  if (faqId) {
    loadFaqDetail(faqId);
  } else {
    error.value = "잘못된 접근입니다.";
    isLoading.value = false;
  }
});
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub1 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub1 {
  background: #f5f5f5;
  padding: 100px 10px;
  text-align: center;
  line-height: 1.7em;
}
.btngroup .divider-line {
  border-top: 1px solid #e0e0e0; /* 선 색상 및 두께 */
  margin-top: 20px; /* 위쪽 여백 */
  margin-bottom: 20px; /* 아래쪽 여백 (버튼과의 간격) */
}
</style>
